import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { NavLink, Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./OptionSet.css";

function OptionSet({
  id,
  title,
  title_english,
  description,
  description_english,
  language,
}) {
  const { t } = useTranslation();

  return (
    <Row className="option-set align-items-center">
      <Col lg={11} className="option-set-header">
        <NavLink className="nav-link" to={`/questionnaire/optionset/${id}`}>
          <h5>{language === "es" ? title : title_english}</h5>
        </NavLink>
        <p>{language === "es" ? description : description_english}</p>
      </Col>
      <Col lg={1} className="option-set-content">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              as={Link}
              to={`/questionnaires/optionsets/edit/${id}`}
            >
              <FontAwesomeIcon icon={faEdit} />{" "}
              {t("Cuestionarios.OptionSets.Set.Editar")}
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to={`/questionnaires/optionsets/delete/${id}`}
            >
              <FontAwesomeIcon icon={faTrash} />{" "}
              {t("Cuestionarios.OptionSets.Set.Eliminar")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}

export default OptionSet;
